module.exports = __webpack_public_path__ + "static/media/fastcoexist.com_3056129_this-house-costs-just-20000-but-its-nicer-than-yours_plot.54f17821.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/fastcoexist.com_3056129_this-house-costs-just-20000-but-its-nicer-than-yours_plot.png
// module id = 391
// module chunks = 0